module.exports = __webpack_public_path__ + "static/img/sider_logo.dbdb7368.svg";